import { stopFeatures, nearbyAttractions } from "@/mocks/galleryPizza";

export default function StopHereSection() {
  return (
    <section id="stop-here" className="bg-[#FAF8F5] py-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-[#1A1A1A] font-black text-6xl md:text-8xl lg:text-9xl leading-none tracking-tight mb-6 uppercase">
            Perfect<br />
            <span className="text-[#FF6B35]">Road Trip</span><br />
            Stop
          </h2>
          <p className="text-[#1A1A1A]/60 text-base max-w-xl mx-auto leading-relaxed">
            Whether you&apos;re heading toward the Highlands, chasing waterfalls, or exploring the South Coast,
            Gallery Pizza Landvegamót is the perfect place to pause, refuel, and enjoy great food.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
          {stopFeatures.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-2xl p-7 flex flex-col gap-4 hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl">
                <i className={`${feature.icon} text-[#FF6B35] text-2xl`} />
              </div>
              <div>
                <h3 className="text-[#1A1A1A] font-bold text-base mb-1">{feature.title}</h3>
                <p className="text-[#1A1A1A]/55 text-sm leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Road Trip Identity */}
        <div className="relative rounded-3xl overflow-hidden min-h-[420px] md:min-h-[500px] flex items-center">
          <img
            src="https://static.readdy.ai/image/9087b38339b011a3e90dfeb23d2afa2c/f087febc42254ac23aad14058e85bb25.jpeg"
            alt="South Iceland road trip landscape"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A]/85 via-[#1A1A1A]/60 to-transparent" />

          <div className="relative z-10 px-10 md:px-16 py-12 max-w-2xl">
            <p className="text-[#FF6B35] text-xs font-semibold tracking-[0.25em] uppercase mb-4">Push the Road Trip Identity</p>
            <h3 className="text-[#FAF8F5] font-extrabold text-3xl md:text-4xl mb-6 leading-tight">
              Your Gateway to<br />South Iceland&apos;s Wonders
            </h3>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {nearbyAttractions.map((attr) => (
                <div key={attr.name} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#FF6B35]/20 rounded-lg shrink-0 mt-0.5">
                    <i className={`${attr.icon} text-[#FF6B35] text-sm`} />
                  </div>
                  <div>
                    <p className="text-[#FAF8F5] font-semibold text-sm">{attr.name}</p>
                    {(attr.distance || attr.description) && (
                      <p className="text-[#FAF8F5]/50 text-xs">
                        {attr.distance}{attr.distance && attr.description ? " \u2022 " : ""}{attr.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <a
              href="https://maps.google.com/?q=Landvegamót,+Hella,+Iceland"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#FF6B35] text-[#1A1A1A] font-bold text-sm px-7 py-3.5 rounded-full hover:bg-[#e55a24] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-map-pin-line" />
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
